require("./m-drawer-list.scss");

var $ = require("jquery");
require("jquery.easing");

var Drawer = function () {
    var $elm = $(this);
    var $head = $('.m-drawer-list__head', $elm);
    var $btn = $('.m-drawer-list__btn', $elm);
    var $outer = $('.m-drawer-list__outer', $elm);
    var isOpen = false;

    var Open = function Open() {
        isOpen = true;
        $btn.addClass("m-drawer-list__btn--open");
        $btn.attr("title", $btn.data("label-close"));
        $btn.text($btn.data("label-close"));
        $outer.slideDown({ duration: 500, easing: "easeOutCubic" });
    }

    var Close = function Close() {
        isOpen = false;
        $btn.removeClass("m-drawer-list__btn--open");
        $btn.attr("title", $btn.data("label-open"));
        $btn.text($btn.data("label-open"));
        $outer.slideUp({ duration: 500, easing: "easeOutCubic" });
    }

    $head.on("click", function () {
        if (!isOpen) {
            Open();
            return;
        }
        Close();
    });
    
    $elm.addClass("m-drawer-list__container--init");
};

$('.m-drawer-list__container').each(Drawer);


// WEBPACK FOOTER //
// ./Sig.Web/src/atomic/molecule/m-drawer-list/m-drawer-list.chunk.js